module.exports = __webpack_public_path__ + "static/media/i-am-that-i-am.e35a2508.txt";